import styled, { css } from 'styled-components'

export const ModalContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 50;
  background: rgba(0, 0, 0, 0.3); ;
`

export const ModalDetail = styled.div`
  width: 100vw;
  padding: 24px;
  background: #ffffff;
  border-radius: 24px 24px 0px 0px;
  padding-bottom: 96px;
  padding-bottom: 128px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  color: #212121;
  gap: 16px;

  .modal_detail_max-width{
    width: 100%;
  }

  .modal_detail_column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .modal_detail_space_between {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
  }
  .modal_detail_head {
    font-family: Inter;
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
  }
  .modal_detail_head_label {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
  }

  .modal_line {
    background: #e0e0e0;
    width: 100%;
    height: 1px;
  }

  .modal_close_button{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content:center;
    border-radius: 8px;
    margin-top: 16px;
    height: 40px;
    background: #ffffff;
    border: 0.5px solid #212121;
    color: #212121;
    font-family: Inter;
font-size: 16px;
font-weight: 500;
line-height: 24px;
text-align: left;

  }
`

interface InvoiceItemStatusProps {
  color?: string
}
export const InvoiceItemStatus = styled.div<InvoiceItemStatusProps>`
  ${({ color }) => css`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${color || '#9E9E9E'};
  `}
`
